import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { Button } from "../ui/button";
import { Scale, ArrowRight } from "lucide-react";

export default function Solutio() {
  const { t } = useLang();
  const bullets = [t("solutio.b1"), t("solutio.b2"), t("solutio.b3"), t("solutio.b4")];

  return (
    <section
      id="solutio"
      data-testid="solutio-section"
      className="relative py-24 md:py-32 bg-[#0D0D0F]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-sm border border-white/10 bg-gradient-to-br from-[#161618] via-[#0D0D0F] to-[#0A0A0A] p-10 md:p-16 lg:p-20">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[#F2B705]/5 blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7">
              <div className="flex items-center gap-3 mb-6">
                <div className="gold-divider" />
                <span className="label-gold">{t("solutio.label")}</span>
              </div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-tight mb-6">
                {t("solutio.title")}
              </h2>
              <p className="text-neutral-300 leading-relaxed text-base lg:text-lg mb-8">
                {t("solutio.body")}
              </p>
              <Link to="/kontakt" data-testid="solutio-cta">
                <Button
                  variant="outline"
                  className="border-[#F2B705]/50 text-[#F2B705] hover:bg-[#F2B705]/10 hover:text-[#F2B705] rounded-sm px-8 py-6 bg-transparent group"
                >
                  <Scale className="mr-2 w-4 h-4" strokeWidth={1.5} />
                  {t("solutio.cta")}
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>

            <div className="lg:col-span-5">
              <ul className="space-y-1">
                {bullets.map((b, i) => (
                  <motion.li
                    key={i}
                    initial={{ opacity: 0, x: 10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.08 }}
                    className="flex items-center gap-4 py-4 border-b border-white/5 last:border-0"
                  >
                    <span className="font-display text-sm font-bold text-[#F2B705] w-8">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="text-neutral-200 text-base">{b}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
